module.exports = __webpack_public_path__ + "img/full-03.5264455f.png";